import React, { useEffect, useState } from 'react'
import { liff } from '../libs'
// import useRewards from '../hooks/rewards/rewards'

export default function VerifyReward() {
    const [isLiff, setIsLiff] = useState(false)
    const [rewardNumber, setRewardNumber] = useState("")
    // const [isDriver, setIsDriver] = useState("")

    // const {
    //     // reward,
    //     // setReward,
    //     // redeemRewardById
    // } = useRewards()

    const openQrReader = async () => {
        const l = await liff.initLiff()
        await l.ready
        if (localStorage.getItem("isDriver") === "true") {
            let data = await l.scanCodeV2()
            let rewardNumberByQr = data.value
            console.log(isLiff)
            console.log(rewardNumber)
            setRewardNumber(rewardNumberByQr)
            // redeemRewardById(rewardNumberByQr)
        } else {
            alert("คุณไม่ใช่คนขับ")
            await l.closeWindow()
        }
    }

    // const verifyRewardNumberByInput = async () => {
    //     redeemRewardById(rewardNumber)
    // }

    const sendMessageToLine = async (msg) => {
        const l = await liff.initLiff()
        await l.ready
        await l.sendMessages([
            {
                type: "text",
                text: msg
            }
        ])
            .then(() => console.log("Message Sent"))
            .catch((err) => console.log(err))
        await l.closeWindow()
    }

    const checkBrowser = async () => {
        const l = await liff.initLiff()
        if (l.isLoggedIn()) {
            if (!l.isInClient()) {
                // alert("ฟังก์ชันกล้องทำงานไม่ได้ เนื่องจากไม่ได้อยู่ใน Line LIFF")
            }
            else setIsLiff(true)
        }
    }

    useEffect(() => {
        if (rewardNumber.length > 0) {
            sendMessageToLine(rewardNumber)
        }
    }, [rewardNumber])

    useEffect(() => {
        checkBrowser()
        openQrReader()
        // eslint-disable-next-line
    }, [])


    if (localStorage.getItem("isDriver") === "false")
        return (<div className='container'>
            <br />
            <h1 align="center">คุณไม่ใช่คนขับ ไม่สามารถใช้งานหน้านี้ได้</h1>
        </div>)
    else if (localStorage.getItem("isDriver") === "true")
        return (
            <div className='container'>
                <br />
                Loading...
                {/* <br />
                <h1 align="center">Verify Reward</h1>
                <br />
                {isLiff && <div>
                    <button
                        className='btn btn-primary'
                        onClick={openQrReader}
                    >สแกนเพื่อตรวจสอบส่วนลด</button>
                    <br />
                    <hr />
                    <h3>หรือ</h3>
                    <hr />
                </div>}
                <div className="row g-3">
                    <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1" className="form-label">
                            กรอกโค้ดส่วนลด
                        </label>
                    </div>
                    <div className="col-auto">
                        <input
                            type="text"
                            className="form-control"
                            value={rewardNumber}
                            onChange={(e) => {
                                let value = e.target.value
                                setRewardNumber(value)
                            }}
                        />
                    </div>
                    <div className="col-auto">
                        <button
                            type="submit"
                            className="btn btn-primary mb-3"
                            onClick={verifyRewardNumberByInput}
                        >
                            Verify
                        </button>
                    </div>
                </div>
                {rewardNumber} */}
            </div>
        )
}
